import { useEffect, useRef, useState } from "react";
import Price from "../../../../components/product/common/Price";
import PackageCta from "../../../../components/product/packages/PackageCta";
import W from '../../../../components/common/Word';
import { isNil } from "lodash";

export default function PackageOrder({ data, shopURL, btnDisable }) {
  
  return (
    <div className={`package__order`}>
        <div className="order-body">
            <div className="package__price">
                {!isNil(data.previous_price) && (
                    <div className="p-prev">
                    <Price value={data.previous_price} />
                    </div>
                )}
                <div className="p-main">
                    <Price value={data.shop_package_price} />
                </div>
                <div className="package__meal">
                    {data.shop_package_frontend_size} /{" "}
                    {parseInt(data.shop_package_total_meals_for_person)} <W>product.meals</W>
                </div>
            </div>
            <div className="package__btn">
                <PackageCta
                    stockStatus={data.shop_product_stock_status}
                    shopUrl={shopURL}
                    btnDisable={btnDisable}
                />
            </div>
        </div>
    </div>
  );
}